import {
	type ManageUserPrivacySettingsSchemaValue,
	transformPrivacySettingsFormatFromApiToSchema,
	transformPrivacySettingsFormatFromSchemaToApi,
} from '../transformers/manage-user-privacy-settings';
import { type CustomResolversContext } from '../types';

const updateUserPrivacySettings = async (
	_: any,
	args: {
		id: string;
		input: Record<ManageUserPrivacySettingsSchemaValue, string>;
	},
	context: CustomResolversContext,
	info: any,
) => {
	const { id, input } = args;
	const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
	const body = JSON.stringify(transformPrivacySettingsFormatFromSchemaToApi(input));
	return context
		.fetch(url, { method: 'PATCH', body })
		.then((data) => data.json())
		.then((data) => transformPrivacySettingsFormatFromApiToSchema(data))
		.then((data) => ({ ...data, id }));
};

export default updateUserPrivacySettings;
